import React, { Component } from 'react';
import { connect } from 'react-redux';
import { isEmpty } from 'lodash';
import BreadCrumbSelector from '../../components/BreadCrumb/BreadCrumbSelector';
import Meisterkachel from '../../components/Meisterkachel/Meisterkachel';
import ContactModal from '../../components/Anfrage/ContactModal';

import { apiGet, apiPost } from '../../../helpers/apiHelper';
import CategoryCards from '../../components/Categories/CategoryCards';

import Spinner from '../../components/Spinner/Spinner';
import { markenStandortSelector } from '../../../modules/selectors/standort/markenStandort';
import Image from '../../components/Image/Image';
import { bindActionCreators } from 'redux';
import { withCookies } from 'react-cookie';
import { standortUrlSelector } from '../../../modules/selectors/url';
import { sessionIdSelector } from '../../../modules/selectors/auth';
import Currency from '../../../helpers/currency';
import { resetSearchStats, setSearchStats } from '../../../modules/actions/search';
import { parseSearch } from '../../../helpers/UrlHelper';
import Button from '../../components/form-elements/Button';
import ServiceCategoryCards from '../../components/ServiceCategories/ServiceCategoryCards';
import ServicenavigatorServicesList from '../../routes/Servicenavigator/ServicenavigatorServiceslists';
import LegacyShopWrapper from '../../LegacyShopWrapper';
import withStandortRouter from '../../components/VHost/withStandortRouter';
import { InternalLink } from '../../components/form-elements/Link';
import { addService } from '../../../modules/actions/standort/session/cart';
import { hideServiceFormSelector } from '../../../modules/selectors/standort/theme';
import { servicenvigatorStatusSelector } from '../../../modules/selectors/standort/service/serviceNavigator';
import ServiceListRow from '../../components/service-list/ServiceListRow';
import ProductListRow from '../../components/product-list/row';

class SearchResults extends Component {
    constructor(props) {
        super(props);
        this.state = {
            categories: [],
            products: [],
            services: [],
            serviceAngebote: [],
            servicenavigator: [],
            loading: true,
            topFilter: {
                showFilter: false,
                showServices: true,
                showServiceAngebote: true,
                showServiceNavigator: true,
                showCategories: true,
                showProducts: true,
            },
            searchResult: {
                somethingFound: false,
                categoriesFound: false,
                productsFound: false,
                servicesFound: false,
                serviceAngeboteFound: false,
                serviceNavigatorFound: false,
                noShownGroups: 0,
            },
        };
        this.getProducts = this.getProducts.bind(this);
        this.getCategories = this.getCategories.bind(this);
        this.getServiceAngebote = this.getServiceAngebote.bind(this);
        this.getAllServices = this.getAllServices.bind(this);
        this.getServicenavigator = this.getServicenavigator.bind(this);
        this.updateSearchResults = this.updateSearchResults.bind(this);
        this.navigateToProduct = this.navigateToProduct.bind(this);
        this.addServiceToCart = this.addServiceToCart.bind(this);
        this.switchToServiceDetail = this.switchToServiceDetail.bind(this);
        this.scrollToTop = this.scrollToTop.bind(this);
        this.goTo = this.goTo.bind(this);
        this.handleChange = this.handleChange.bind(this);
        this.isNoa = this.props.markenStandort.gesellschafterNr == "035"
    }

    getProducts(resolve, reject) {
        apiGet(
            '/api/v1/Search/Products',
            {
                standortUrl: this.props.standortUrl,
                regexp: this.props.searchValue,
            },
            (err, response) => {
                if (err) {
                    reject(err);
                } else {
                    if (response && response.data) {
                        const products = response.data;
                        resolve(products);
                    } else {
                        resolve();
                    }
                }
            }
        );
        this.setState({ loading: false });
    }

    getCategories(resolve, reject) {
        apiGet(
            '/api/v1/Search/Categories',
            {
                standortUrl: this.props.standortUrl,
                regexp: this.props.searchValue,
            },
            (err, response) => {
                if (err) {
                    reject(err);
                } else {
                    if (response && response.data) {
                        let categories = response.data;
                        if (this.props.serviceNavigatorStatus) {
                            categories = categories.filter(item => item.url !== "reparatur-wartung");
                        }

                        // NOA Employee Category should never be visible in search results.
                        resolve(categories.filter(category => !category.isNOAEmployeeCategory));
                    } else {
                        resolve();
                    }
                }
            }
        );
        this.setState({ loading: false });
    }

    getServiceAngebote(resolve, reject) {
        if (!this.props.hideServiceForm && !this.props.serviceNavigatorStatus) {
            apiGet(
                '/api/v1/Search/ServiceAngebote',
                { standortUrl: this.props.standortUrl, regexp: this.props.searchValue },
                (err, response) => {
                    if (err) {
                        console.error('SearchResults getServiceAngebote err:', err);
                        reject(err);
                    } else {
                        if (response && response.data) {
                            const serviceAngebote = response.data;
                            resolve(serviceAngebote);
                        } else {
                            resolve();
                        }
                    }
                }
            );
        } else {
            resolve();
        }
        this.setState({ loading: false });
    }

    getAllServices(resolve, reject) {
        if (this.props.standortUrl && this.props.standortUrl !== 'de' && !this.props.hideServiceForm && !this.props.serviceNavigatorStatus) {
            // services national machen wenig Sinn => keine serviceAngebote und nur SEO-Texte
            //if (this.props.standortUrl) {
            apiPost('/api/v1/Search/GetAllServices', { standortUrl: this.props.standortUrl }, (err, response) => {
                if (err) {
                    console.error('SearchResults getAllServices err:', err);
                    reject(err);
                } else {
                    if (response) {
                        resolve(response);
                    }
                }
            });
        } else {
            resolve();
        }
        this.setState({ loading: false });
    }

    getServicenavigator(resolve, reject) {
        if (this.props.standortUrl && this.props.markenStandort._id && this.props.serviceNavigatorStatus) {
            apiPost('/api/v1/Search/GetServicenaviator', { standortUrl: this.props.standortUrl, standortId: this.props.markenStandort._id }, (err, response) => {
                if (err) {
                    console.error('SearchResults get Servicenaviator services err:', err);
                    reject(err);
                } else {
                    if (response) {
                        resolve(response);
                    }
                }
            });
        } else {
            resolve();
        }
        this.setState({ loading: false });
    }

    updateSearchResults() {
        const getProducts = new Promise(this.getProducts);
        const getCategories = new Promise(this.getCategories);
        const getAllServices = new Promise(this.getAllServices);
        const getServiceAngebote = new Promise(this.getServiceAngebote);
        const getServicenavigator = new Promise(this.getServicenavigator);
        this.setState({ loading: true });

        Promise.all([getProducts, getCategories, getAllServices, getServiceAngebote, getServicenavigator])
            .then(([products, categories, otservices, serviceAngebote, servicenavigator]) => {
                if (serviceAngebote?.length === 0) {
                    // keine serviceAngebote => services nur anzeigen,
                    // wenn Suchbegriff in synonymen order Bezeichnung enthalten ist
                    let sort = 0;
                    if (otservices && otservices.length > 0) {
                        otservices = otservices.filter(service => {
                            if (
                                service.synonyme.toLowerCase().includes(this.props.searchValue.toLowerCase()) ||
                                service.bezeichnung.toLowerCase().includes(this.props.searchValue.toLowerCase())
                            ) {
                                if (service.url === 'serviceAnfrage') {
                                    service.sort = otservices.length + 1;
                                } else {
                                    service.sort = sort++;
                                }
                                return service;
                            } else {
                                if (service.url === 'serviceAnfrage') {
                                    service.sort = otservices.length + 1;
                                    return service;
                                } else return null;
                            }
                        });
                        // "serviceAnfrage" in services nur anzeigen, wenn ein weiterer Service gefunden wird
                        if (otservices.length === 1) {
                            otservices = [];
                        }
                    }
                    if (servicenavigator && servicenavigator.length > 0) {
                        servicenavigator = servicenavigator.filter(service => {
                            if (
                                service?.serviceName?.toLowerCase().includes(this.props.searchValue.toLowerCase()) ||
                                service?.serviceType?.toLowerCase().includes(this.props.searchValue.toLowerCase())
                            ) {
                                if (service.services && service.services.length > 0) {
                                    service.services = service.services.filter(service => {
                                        if (service?.serviceTitle?.toLowerCase().includes(this.props.searchValue.toLowerCase()) ||
                                            service?.serviceUrl?.toLowerCase().includes(this.props.searchValue.toLowerCase())) {
                                            service.sort = sort++;
                                            return service;
                                        } else {
                                            return service;
                                        }
                                    });
                                }
                                if (service.services && service.services.length > 0) {
                                    service.sort = sort++;
                                    return service;
                                } else return null;
                            } else {
                                if (service.services && service.services.length > 0) {
                                    service.services = service.services.filter(service => {
                                        if (service?.serviceTitle?.toLowerCase().includes(this.props.searchValue.toLowerCase()) ||
                                            service?.serviceUrl?.toLowerCase().includes(this.props.searchValue.toLowerCase())) {
                                            service.sort = sort++;
                                            return service;
                                        } else {
                                            return null;
                                        }
                                    });

                                    if (service.services && service.services.length > 0) {
                                        return service;
                                    } else return null;
                                }
                            }
                        });
                    }

                } else {
                    let sort = 0;
                    if (servicenavigator && servicenavigator.length > 0) {
                        servicenavigator = servicenavigator.filter(service => {
                            if (
                                service?.serviceName?.toLowerCase().includes(this.props.searchValue.toLowerCase()) ||
                                service?.serviceType?.toLowerCase().includes(this.props.searchValue.toLowerCase())
                            ) {

                                if (service.services && service.services.length > 0) {
                                    service.services = service.services.filter(service => {
                                        if (service?.serviceTitle?.toLowerCase().includes(this.props.searchValue.toLowerCase()) ||
                                            service?.serviceUrl?.toLowerCase().includes(this.props.searchValue.toLowerCase())) {
                                            service.sort = sort++;
                                            return service;
                                        } else {
                                            return service;
                                        }
                                    });
                                }
                                if (service.services && service.services.length > 0) {
                                    service.sort = sort++;
                                    return service;
                                } else return null;
                            } else {
                                if (service.services && service.services.length > 0) {
                                    service.services = service.services.filter(ser => {
                                        if (ser?.serviceTitle?.toLowerCase().includes(this.props.searchValue.toLowerCase()) ||
                                            ser?.serviceUrl?.toLowerCase().includes(this.props.searchValue.toLowerCase())) {
                                            ser.sort = sort++;
                                            return ser;
                                        } else {
                                            return null;
                                        }
                                    });

                                    if (service.services && service.services.length > 0) {
                                        return service;
                                    } else return null;
                                }
                            }
                        });
                    }
                    //1. fehlende Zuordnungen bei Titelsuche: (serviceAngebote ohne haendlerService)
                    //   bei den services wird dort aufwändig in der Hierarchie des standortes gesucht
                    //   hier ist dies bereits im Ergebnis des azure search enthalten
                    serviceAngebote?.forEach(service => {
                        if (!service.serviceTitle && service.kategorie) {
                            let foundOtservice = otservices.find(result => result.url.toString() === service.kategorie.toString());
                            if (foundOtservice && foundOtservice.title) {
                                service.serviceTitle = foundOtservice.title;
                            }
                            return service;
                        }
                    });

                    //2. nur die services anzeigen, für die es ein serviceAngebot gibt (+ service "serviceAnfrage")
                    if (otservices) {
                        let sort = 0;
                        otservices = otservices.filter(service => {
                            if (service.url === 'serviceAnfrage') {
                                service.sort = otservices.length + 1;
                                return service;
                            } else {
                                let foundService = serviceAngebote.find(result => result.kategorie.toString() === service.url.toString());
                                if (foundService) {
                                    service.sort = sort++;
                                    return service;
                                } else {
                                    return null;
                                }
                            }
                        });
                    }
                }
                let somethingFound = true;
                let showFilter = true;

                // Suchergebnis Auswertung
                let categoriesFound = !isEmpty(categories);
                let productsFound = !isEmpty(products);
                let servicesFound = !isEmpty(otservices);
                let serviceAngeboteFound = !isEmpty(serviceAngebote);
                let serviceNavigatorFound = !isEmpty(servicenavigator);

               

                // Filteranzeige: wenn nichts gefunden, oder nur ein Bereich
                // products + categories bzw. services + serviceAngebote, dann kein Filter
                if (!categoriesFound && !productsFound && !servicesFound && !serviceAngeboteFound && !serviceNavigatorFound) {
                    somethingFound = false;
                    showFilter = false;
                } else {
                    if ((!categoriesFound && !productsFound) || ((!servicesFound && !serviceAngeboteFound) || !serviceNavigatorFound)) {
                        showFilter = false;
                    }
                    if(serviceNavigatorFound) {
                        showFilter = true;
                    }
                }

                const count =
                    (products?.length ?? 0) + (categories?.length ?? 0) + (serviceAngebote?.length ?? 0) + (otservices?.length ?? 0);

                this.props.setSearchStats({ term: this.props.searchValue, count });

                let noShownGroups = 0;
                if (showFilter && servicesFound) noShownGroups++;
                if (showFilter && serviceAngeboteFound) noShownGroups++;
                if (showFilter && categoriesFound) noShownGroups++;
                if (showFilter && productsFound) noShownGroups++;
                if (showFilter && serviceNavigatorFound) noShownGroups++;
                this.setState({
                    loading: false,
                    products: products,
                    categories: categories,
                    serviceAngebote: serviceAngebote,
                    services: otservices ? otservices.sort((a, b) => a.sort - b.sort) : [],
                    serviceNavigator: servicenavigator ? servicenavigator.sort((a, b) => a.sort - b.sort) : [],
                    topFilter: {
                        showFilter: showFilter,
                        showServices: servicesFound,
                        showServiceAngebote: serviceAngeboteFound,
                        showServiceNavigator: serviceNavigatorFound,
                        showCategories: categoriesFound,
                        showProducts: productsFound,
                        noShownGroups: noShownGroups,
                    },
                    searchResult: {
                        somethingFound: somethingFound,
                        categoriesFound: categoriesFound,
                        productsFound: productsFound,
                        servicesFound: servicesFound,
                        serviceAngeboteFound: serviceAngeboteFound,
                        serviceNavigatorFound: serviceNavigatorFound,
                    },
                });
            })
            .catch(err => console.error(err));
    }

    navigateToProduct(product) {
        if (product && (product.id || product.slug != null)) {
            this.props.history.push(`/${product.categories[0]}/${(product.slug != null ? product.slug : product.id)}`);
        }
    }

    addServiceToCart(event, service) {
        event.preventDefault();
        this.props.addService({ service });
    }

    switchToServiceDetail(service) {
        this.props.history.push(`/reparatur-wartung/${service.kategorie}/${service._id}`);
    }

    scrollToTop() {
        document.querySelector('html,body').scrollIntoView({ behavior: 'smooth' });
    }

    goTo(targetId) {
        if (targetId) {
            if (targetId === 'anchorServices' && this.state.searchResult.servicesFound) {
                this.setState({
                    ...this.state,
                    topFilter: {
                        ...this.state.topFilter,
                        showServices: true,
                        showFilter: true,
                    },
                });
            }
            if (targetId === 'anchorServiceAngebote' && this.state.searchResult.serviceAngeboteFound) {
                this.setState({
                    ...this.state,
                    topFilter: {
                        ...this.state.topFilter,
                        showServices: false,
                        showServiceAngebote: true,
                        showFilter: true,
                    },
                });
            }
            if (targetId === 'anchorCategories' && this.state.searchResult.categoriesFound) {
                this.setState({
                    ...this.state,
                    topFilter: {
                        ...this.state.topFilter,
                        showServices: false,
                        showServiceAngebote: false,
                        showCategories: true,
                        showFilter: true,
                    },
                });
            }
            if (targetId === 'anchorProducts' && this.state.searchResult.productsFound) {
                this.setState({
                    ...this.state,
                    topFilter: {
                        ...this.state.topFilter,
                        showServices: false,
                        showServiceAngebote: false,
                        showCategories: false,
                        showProducts: true,
                        showFilter: true,
                    },
                });
            }
        }
    }

    componentDidUpdate(prevProps, _prevState, _snapshot) {
        if (prevProps.searchValue !== this.props.searchValue) this.updateSearchResults();
    }

    componentDidMount() {
        this.updateSearchResults();
    }

    componentWillUnmount() {
        this.props.resetSearchStats();
    }

    handleChange(event, key) {
        if (this.state.topFilter.noShownGroups === 1 && event.target.checked === false) {
            
            // nicht erlaubt: zumindest ein Bereich muss ausgewählt sein
            // => Änderung übergehen vorerst ohne Meldung
        } else {
            let noShownGroups = this.state.topFilter.noShownGroups;
            if (event.target.checked) {
                noShownGroups++;
            } else {
                noShownGroups--;
            }
            if (key === 'topFilter.showServices') {
                this.setState({
                    ...this.state,
                    topFilter: {
                        ...this.state.topFilter,
                        showServices: !this.state.topFilter.showServices,
                        noShownGroups: noShownGroups,
                    },
                });
            }
            if (key === 'topFilter.showServiceNavigator') {
                this.setState({
                    ...this.state,
                    topFilter: {
                        ...this.state.topFilter,
                        showServiceNavigator: !this.state.topFilter.showServiceNavigator,
                        noShownGroups: noShownGroups,
                    },
                });
            }
            if (key === 'topFilter.showServiceAngebote') {
                this.setState({
                    ...this.state,
                    topFilter: {
                        ...this.state.topFilter,
                        showServiceAngebote: !this.state.topFilter.showServiceAngebote,
                        noShownGroups: noShownGroups,
                    },
                });
            }
            if (key === 'topFilter.showCategories') {
                this.setState({
                    ...this.state,
                    topFilter: {
                        ...this.state.topFilter,
                        showCategories: !this.state.topFilter.showCategories,
                        noShownGroups: noShownGroups,
                    },
                });
            }
            if (key === 'topFilter.showProducts') {
                this.setState({
                    ...this.state,
                    topFilter: {
                        ...this.state.topFilter,
                        showProducts: !this.state.topFilter.showProducts,
                        noShownGroups: noShownGroups,
                    },
                });
            }
        }
    }

    render() {
        const { markenStandort, hideServiceForm } = this.props;
        const { products, categories, serviceAngebote, services, serviceNavigator, loading } = this.state;
        const { topFilter, searchResult } = this.state;
        let isNoa = markenStandort.url.includes("nord-ost")

        Array.isArray(products) && products.forEach(element => {
            if (element.imagelink.includes('techno-images.s3.eu-central-1.amazonaws.com')) {
                element.imagelink = element.imagelink.replace(/%20| /g, '+')
            } else if (element.imagelink.includes('technoshopautohaus.blob.core.windows.net') && !element.imagelink.includes('.jpg') && !element.imagelink.includes('.png')) {
                let image_url = element.imagelink.replace('https://technoshopautohaus.blob.core.windows.net', 'https://techno-images.s3.eu-central-1.amazonaws.com');
                let image = `${image_url}.jpg`;
                element.imagelink = image;
            } else if (element.imagelink.includes('technoshopautohaus.blob.core.windows.net') && element.imagelink.includes('.jpg')) {
                let image_url = element.imagelink.replace('https://technoshopautohaus.blob.core.windows.net', 'https://techno-images.s3.eu-central-1.amazonaws.com');
                element.imagelink = image_url;
            } else if (element.imagelink.includes('technoshopautohaus.blob.core.windows.net') && element.imagelink.includes('.png')) {
                let image_url = element.imagelink.replace('https://technoshopautohaus.blob.core.windows.net', 'https://techno-images.s3.eu-central-1.amazonaws.com');
                element.imagelink = image_url;
            }
        });

        return (
            <>
                <BreadCrumbSelector additionalCrumbs={[{ label: 'Suchergebnis' }]} />
                {!loading ? (
                    <LegacyShopWrapper>
                        {searchResult.somethingFound && topFilter.showFilter ? (
                            // Top Filter bei gemischten Ergebnissen
                            <div className="top_filter">
                                <div className="filter_header">
                                    <h4 className="filter_header_text">Ergebnisauswahl:</h4>
                                </div>
                                <div id="elem_container">
                                    {!hideServiceForm && topFilter.showFilter && searchResult.servicesFound ? (
                                        <div className="filter_elem">
                                            <p className="filter_text">Services</p>
                                            <input
                                                type="checkbox"
                                                className="uk-checkbox filter_checkbox"
                                                onChange={event => {
                                                    this.handleChange(event, 'topFilter.showServices');
                                                }}
                                                checked={topFilter.showServices}
                                            />
                                            <button
                                                className="goTo"
                                                title="navigieren zu Ergebnis in Services"
                                                onClick={() => this.goTo('anchorServices')}
                                            >
                                                <i className="fa fa-angle-double-right" />
                                            </button>
                                        </div>
                                    ) : null}
                                    {!hideServiceForm && topFilter.showFilter && searchResult.serviceNavigatorFound ? (
                                        <div className="filter_elem">
                                            <p className="filter_text">Services</p>
                                            <input
                                                type="checkbox"
                                                className="uk-checkbox filter_checkbox"
                                                onChange={event => {
                                                    this.handleChange(event, 'topFilter.showServiceNavigator');
                                                }}
                                                checked={topFilter.showServiceNavigator}
                                            />
                                            <button
                                                className="goTo"
                                                title="navigieren zu Ergebnis in Services"
                                                onClick={() => this.goTo('anchorServices')}
                                            >
                                                <i className="fa fa-angle-double-right" />
                                            </button>
                                        </div>
                                    ) : null}
                                    {!hideServiceForm && topFilter.showFilter && searchResult.serviceAngeboteFound ? (
                                        <div className="filter_elem">
                                            <p className="filter_text">Serviceangebote</p>
                                            <input
                                                type="checkbox"
                                                className="uk-checkbox filter_checkbox"
                                                onChange={event => {
                                                    this.handleChange(event, 'topFilter.showServiceAngebote');
                                                }}
                                                checked={topFilter.showServiceAngebote}
                                            />
                                            <button
                                                className="goTo"
                                                title="navigieren zu Ergebnis in Serviceangeboten"
                                                onClick={() => this.goTo('anchorServiceAngebote')}
                                            >
                                                <i className="fa fa-angle-double-right" />
                                            </button>
                                        </div>
                                    ) : null}
                                    {topFilter.showFilter && searchResult.categoriesFound ? (
                                        <div className="filter_elem">
                                            <p className="filter_text">Produktkategorien</p>
                                            <input
                                                type="checkbox"
                                                className="uk-checkbox filter_checkbox"
                                                onChange={event => {
                                                    this.handleChange(event, 'topFilter.showCategories');
                                                }}
                                                checked={topFilter.showCategories}
                                            />
                                            <button
                                                className="goTo"
                                                title="navigieren zu Ergebnis in Produktkategorien"
                                                onClick={() => this.goTo('anchorCategories')}
                                            >
                                                <i className="fa fa-angle-double-right" />
                                            </button>
                                        </div>
                                    ) : null}
                                    {topFilter.showFilter && searchResult.productsFound ? (
                                        <div className="filter_elem">
                                            <p className="filter_text">Produkte</p>
                                            <input
                                                type="checkbox"
                                                className="uk-checkbox filter_checkbox"
                                                onChange={event => {
                                                    this.handleChange(event, 'topFilter.showProducts');
                                                }}
                                                checked={topFilter.showProducts}
                                            />
                                            <button
                                                className="goTo"
                                                title="navigieren zu Ergebnis in Produkten"
                                                onClick={() => this.goTo('anchorProducts')}
                                            >
                                                <i className="fa fa-angle-double-right" />
                                            </button>
                                        </div>
                                    ) : null}
                                </div>
                            </div>
                        ) : null}
                        {!searchResult.somethingFound ? (
                            // Meisterkachel und Button Anfrageformular (bei nichts gefunden)
                            <>
                                <section className="uk-section uk-section-muted uk-section-small">
                                    <div className="uk-container uk-container-xsmall">
                                        <Meisterkachel />
                                    </div>
                                </section>
                                <div className="green_box_container">
                                    <div className="uk-margin-small-right" />
                                    <div className="uk-flex">
                                        <div className="uk-flex-right location-text" style={{ padding: '10px' }}>
                                            <h4 style={{ color: 'white' }}>
                                                {markenStandort && markenStandort.url === 'de' ? (
                                                    <p>Sie haben Ihr gewünschtes Produkt nicht gefunden?</p>
                                                ) : (
                                                    <p>Sie haben Ihr gewünschtes Produkt oder Ihren gewünschten Service nicht gefunden?</p>
                                                )}
                                            </h4>
                                            <p style={{ color: 'white' }}>
                                                Senden Sie uns hier eine Anfrage - unsere Partnerwerkstatt wird Sie kontaktieren.
                                            </p>
                                        </div>
                                    </div>
                                    <ContactModal>
                                        {({ openModal }) => (
                                            <Button fullWidth modifier="secondary" onClick={openModal}>
                                                ZUM ANFRAGEFORMULAR
                                            </Button>
                                        )}
                                    </ContactModal>
                                </div>
                            </>
                        ) : null}
                        {!hideServiceForm && services && topFilter.showServices ? (
                            // Services
                            <div id="anchorServices" className="services">
                                <div className="service_categories">
                                    <div className="service_categories_container">
                                        <h4>Services:</h4>
                                        <ServiceCategoryCards dienstleistungen={services} trackingAction="Klick-Servicekachel-Search" />
                                    </div>
                                </div>
                            </div>
                        ) : null}
                        {!hideServiceForm && serviceNavigator && topFilter.showServiceNavigator ? (
                            // Services
                            <div id="anchorServices" className="services">
                                <div className="service_categories">
                                    <div className="service_categories_container">
                                        <h4>Services:</h4>
                                        <ServicenavigatorServicesList Services={serviceNavigator} />
                                    </div>
                                </div>
                            </div>
                        ) : null}
                        {!hideServiceForm && serviceAngebote && topFilter.showServiceAngebote ? (
                            // serviceAngebote
                            <div id="anchorServiceAngebote" className="uk-container">
                                <div className="uk-section">
                                    <div className="uk-grid uk-grid-small uk-child-width-1-1@m" data-uk-grid="">
                                        {serviceAngebote.map(service => (
                                            <div key={service._id}>
                                                <ServiceListRow service={service} />
                                            </div>
                                        ))}
                                    </div>
                                </div>
                            </div>
                        ) : null}
                        {!loading && categories && categories.length && this.props.location && topFilter.showCategories ? (
                            // Produktkategorien
                            <>
                                <div id="anchorCategories" className="found-categories">
                                    {categories.length > 1 ? (
                                        <h4 className="category_list_title">Produktkategorien:</h4>
                                    ) : (
                                        <h4 className="category_list_title">Produktkategorie:</h4>
                                    )}
                                    <CategoryCards categories={categories} />
                                </div>
                                <div style={{ clear: 'both' }} />
                            </>
                        ) : null}
                        {!loading && products && topFilter.showProducts ? (
                            // Produkte
                            <div id="anchorProducts" className='uk-container'>
                                {products.length > 0 ? (
                                    <div className="uk-grid uk-grid-small uk-child-width-1-1@m uk-margin-top" data-uk-grid="">
                                        {/*//TODO: Paginaierung in Map*/}
                                        {products.map(product => (
                                            <div key={product.id} className='uk-margin-large-top'>                                                
                                                <ProductListRow product={product} />
                                            </div>
                                        ))}
                                    </div>
                                ) : null}
                                <div style={{ clear: 'both' }} />
                                <div className="list_footer">
                                    <div className="left_side">
                                        <button className="scroll_top" onClick={this.scrollToTop}>
                                            <i className="fa fa-angle-up" />
                                            Nach oben
                                        </button>
                                    </div>
                                    <div className="middle">
                                        Inkl. MwSt., zzgl. etwaiger{' '}
                                        <InternalLink to="/versandkosten" className="delivery_link">
                                            <u>Versandkosten</u>
                                        </InternalLink>
                                    </div>
                                </div>
                                <div style={{ clear: 'both' }} />
                            </div>
                        ) : null}
                    </LegacyShopWrapper>
                ) : (
                    <div>
                        <Spinner />
                    </div>
                )}
            </>
        );
    }
}

const mapStateToProps = (state, ownProps) => ({
    markenStandort: markenStandortSelector(state),
    standortUrl: standortUrlSelector(state),
    searchValue: parseSearch(ownProps.location.search).q,
    sessionId: sessionIdSelector(state),
    hideServiceForm: hideServiceFormSelector(state),
    serviceNavigatorStatus: servicenvigatorStatusSelector(state),
});
const mapDispatchToProps = dispatch => bindActionCreators({ addService, setSearchStats, resetSearchStats }, dispatch);

export default withStandortRouter(withCookies(connect(mapStateToProps, mapDispatchToProps)(SearchResults)));
